var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.getDomainsTransferList.length
    ? _c(
        "gg-card",
        {
          staticClass: "my-5"
        },
        [
          _c(
            "gg-card-header",
            [
              _vm._v(" My Pending Transfers "),
              _c(
                "gg-btn",
                {
                  staticStyle: {
                    float: "right"
                  },
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.refreshClick
                  }
                },
                [_vm._v("Refresh")]
              )
            ],
            1
          ),
          _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  loading: _vm.loading,
                  headers: _vm.headers,
                  items: _vm.getDomainsTransferList,
                  "footer-props": {
                    itemsPerPageOptions: _vm.pagination
                  },
                  search: _vm.search
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.domain",
                      fn: function fn(_ref) {
                        var item = _ref.item
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "ggs-item-title",
                              attrs: {
                                to: "/domaintransfer/".concat(item.id)
                              }
                            },
                            [_vm._v(" " + _vm._s(item.domain) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.status",
                      fn: function fn(_ref2) {
                        var item = _ref2.item
                        return [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                small: "",
                                color: _vm.statusColor(item.status)
                              }
                            },
                            [_vm._v(" mdi-circle ")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "pl-1"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("capitalize")(item.status)) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.actions",
                      fn: function fn(_ref3) {
                        var item = _ref3.item
                        return [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                color: "primary",
                                tile: "",
                                to: "/domaintransfer/".concat(item.id)
                              }
                            },
                            [_vm._v(" Manage ")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  245388152
                )
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }